import React from "react";
import Text from "../typography/Text";
import useMedia from "../../hooks/useMedia";
import Image from "../images/Image";

const MediumArticle = ({
  title,
  excerpt,
  image,
  date,
  read_time,
  medium_link
}) => {
  const media = useMedia();
  return (
    <div className="mediumArticle">
      <div
        className="mediumArticle_image"
        onClick={() => window.open(medium_link, "_blank")}
      >
        <Image image={image} alt={image ? image.alt : ""} />
      </div>
      <div className="mediumArticle_content">
        <div className="mediumArticle_time">
          <Text small>
            {date}
            {read_time ? ` · ${read_time} min read` : ""}
          </Text>
        </div>
        <h4
          className="mediumArticle_title"
          onClick={() => window.open(medium_link, "_blank")}
        >
          {title ? title.rendered : ""}
          {media === "mobile" && (
            <div className="mediumArticle_arrowRight">{" ->"}</div>
          )}
        </h4>
        <div className="mediumArticle_excerpt">
          <Text>{excerpt}</Text>
        </div>
        <a
          className="mediumArticle_link"
          href={medium_link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Read more <div className="mediumArticle_arrowRight">{" ->"}</div>
        </a>
      </div>
    </div>
  );
};

export default MediumArticle;
